(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamSpecialtyController', CareTeamSpecialtyController);

    CareTeamSpecialtyController.$inject = ['$scope', '$state', 'CareTeamSpecialty', 'CareTeamSpecialtySearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function CareTeamSpecialtyController ($scope, $state, CareTeamSpecialty, CareTeamSpecialtySearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.careTeamSpecialties = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  CareTeamSpecialty.query(function(result) {
                  vm.careTeamSpecialties = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.careTeamSpecialties, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            CareTeamSpecialty.query(function(result) {
                vm.careTeamSpecialties = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();
